import { makeHighPriorityStyles } from 'utils/stylesWrapper';
import { Theme } from '@material-ui/core/styles';

const useFilterAndActionControlsStyles = makeHighPriorityStyles((theme: Theme) => ({
    rootContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        borderTop: 'none',

        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(2, 0),
        },
        [theme.breakpoints.down('xs')]: {
            border: 'none',
            width: '100%',
        },
    },
    controlsContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        marginLeft: theme.spacing(4),
        marginTop: theme.spacing(2),
        height: theme.spacing(4),

        [theme.breakpoints.down('xs')]: {
            display: 'flex',
            margin: 0,
            width: '100%',
            height: theme.spacing(5),
        },
    },
    hidden: {
        visibility: 'hidden',
    },
    filterButton: {
        marginRight: theme.spacing(2),
    },
}));

export default useFilterAndActionControlsStyles;
